import { Tooltip } from "antd";
import React, { useContext } from "react";
import { useSearchParams  } from "react-router-dom";
import defaultProductPic from "Images/default-brand.jpg";
import { gotoPdp } from "Utils/activityHelper";
import { formatPrice } from "Utils/common";
import { AppContext } from "Store";
import { USER_TYPE } from "Utils/constant";
import { Bundle, Product } from "src/types/global";

const MBunldeCard = ({ bundle, previewFlag, activityId }: 
  { bundle: Bundle | undefined, previewFlag: boolean, activityId?: string }) => {
    const [searchParams] = useSearchParams();
    const filter = searchParams.get('filter');
  const { loginState } =
    useContext(AppContext);
  const isEmployee = loginState?.userType === USER_TYPE.EMPLOYEE;
  const products: Product[] | undefined = bundle?.products;
  if (!bundle) return null;
  if (!products || !products.length) return null;
  console.log("MBunldeCard filter", filter);
  return (
    <div className="productsWrapper bundleCardWrapper">
      {products.map((product: Product, index: number) => {
        console.log(product, index);
        return (
          <div className="productCardWrapper">
            <div className="productCard">
              <div className="imgWrapper">
                <img
                  alt={product.productName}
                  src={product.productPic || defaultProductPic}
                  onClick={() => {
                    const isReturnBtn = true;
                    console.log("going to pdp filter", filter);
                    gotoPdp(product, loginState, "Bundle_Detail", isReturnBtn, filter, activityId);
                  }}
                ></img>
              </div>
              <div className="right">
                <div className="line line1">
                  <span>{product.sku}</span>
                  {product.productSize && (
                    <>
                      <span className="vdivider"></span>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: product.productSize,
                        }}
                      ></span>
                    </>
                  )}
                </div>
                <Tooltip
                  title={
                    <div
                      dangerouslySetInnerHTML={{ __html: product.productName }}
                    ></div>
                  }
                  trigger={"hover"}
                >
                  <div
                    className={
                      product.pdpViewable && !isEmployee ? "line line2 linkable" : "line line2"
                    }
                    style={{ color: isEmployee ? undefined : "#005daa" }}
                    onClick={() => {
                      console.log("product card clicked");
                      const isReturnBtn = true;
                      console.log("going to pdp filter", filter);
                      gotoPdp(product, loginState, "Bundle_Detail", isReturnBtn, filter, activityId);
                    }}
                    dangerouslySetInnerHTML={{ __html: product.productName }}
                  ></div>
                </Tooltip>
                {product.description && (
                  <Tooltip title={product.description} trigger={"hover"}>
                    <div
                      className="line line3"
                      dangerouslySetInnerHTML={{ __html: product.description }}
                    ></div>
                  </Tooltip>
                )}
                <div className="line line5">
                  <div
                    className={
                      previewFlag
                        ? "lightText priceItem"
                        : "primaryText priceItem"
                    }
                  >
                    {formatPrice(product.finalPrice)}
                  </div>
                  <div className="priceItem lightText lineThrough">
                    {formatPrice(product.listPrice)}
                  </div>
                  <div>X {product.componentQuantity}</div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MBunldeCard;
